import { createStore, compose, applyMiddleware } from 'redux'
import { REHYDRATE } from 'redux-persist/constants'
import createActionBuffer from 'redux-action-buffer'
import reducer, { defaultState } from './reducer'

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose

export default createStore(
    reducer,
    defaultState,
    composeEnhancers(
        applyMiddleware(
            // Make sure to apply this after redux-thunk et al.
            createActionBuffer(REHYDRATE)
        )
    )
)
